import {
  FetchUsersResponse,
  HasPendingResponse,
  StatusType,
  UpdateUserResponse,
  UserWithMetadata,
} from '@/types';
import client from './client';

async function list({
  currentPage,
  limit,
  sortBy,
  sortOrder,
  searchQuery,
}: {
  currentPage: number;
  limit: number;
  sortBy: 'email' | 'timeJoined' | 'lastLoggedIn';
  sortOrder: 'asc' | 'desc';
  searchQuery: string;
}) {
  const { data } = await client.get<FetchUsersResponse>('/users', {
    params: {
      currentPage,
      limit,
      sortBy,
      sortOrder,
      searchQuery,
    },
  });
  return data;
}

async function getAll() {
  const { data } = await client.get<UserWithMetadata[]>('/users/export');
  return data;
}

async function update({
  userId,
  newStatus,
  newOrg,
}: {
  userId: string;
  newStatus?: StatusType;
  newOrg?: string;
}) {
  const { data } = await client.patch<UpdateUserResponse>(`/users/${userId}`, {
    ...(newStatus && { newStatus }),
    ...(newOrg && { newOrg }),
  });
  return data;
}

async function checkPending() {
  const { data } = await client.get<HasPendingResponse>('/users/has-pending');
  return data;
}

async function reset2FA(userId: string) {
  const { data } = await client.post(`/admin/users/${userId}/reset-2fa`);
  return data;
}

export const usersManage = {
  list,
  getAll,
  update,
  checkPending,
  reset2FA,
};
